import { useState } from 'react';
import {
  DocumentTextIcon,
  VideoCameraIcon,
  GlobeAltIcon,
  MagnifyingGlassIcon,
  UserGroupIcon,
  PlusIcon,
  PhotoIcon,
  NewspaperIcon,
  EnvelopeIcon,
  RectangleGroupIcon
} from '@heroicons/react/24/outline';
import PerformanceMetric from './PerformanceMetric';
import QuickCreateCard from './QuickCreateCard';
import SetupStep from './SetupStep';
import Campaign from './Campaign';
import LocationSwitcher from './LocationSwitcher';

function StrategyDashboard() {
  const [selectedRegion, setSelectedRegion] = useState('gcc');
  const [selectedCountry, setSelectedCountry] = useState('uae');
  const [selectedPlatform, setSelectedPlatform] = useState('all');

  const performanceMetrics = [
    { name: 'Global Score', score: 70, connected: true },
    { name: 'Emails', score: 60, connected: true },
    { name: 'Ads', score: 75, connected: true },
    { name: 'SEO', score: 40, connected: true },
    { name: 'Website', score: 55, connected: true },
    { name: 'Social', score: 90, connected: true }
  ];

  const quickCreateItems = [
    { title: 'New Campaign', icon: DocumentTextIcon },
    { title: 'Social Post', icon: PhotoIcon, bgColor: 'bg-indigo-50' },
    { title: 'Product SEO', icon: MagnifyingGlassIcon, bgColor: 'bg-purple-50' },
    { title: 'Blog Post SEO', icon: NewspaperIcon, bgColor: 'bg-pink-50' },
    { title: 'Newsletter', icon: EnvelopeIcon, bgColor: 'bg-yellow-50' },
    { title: 'Website Banner', icon: RectangleGroupIcon, bgColor: 'bg-green-50' }
  ];

  const setupSteps = [
    {
      title: 'Complete your business DNA',
      description: 'This will enable us to generate recommendations & more personalized content for you',
      status: 'pending',
      action: 'Edit'
    },
    {
      title: 'Unlock growth with Google Analytics integration',
      description: 'Elevate your store\'s potential by connecting with Google Analytics',
      status: 'pending',
      action: 'Connect'
    },
    {
      title: 'Generate your first content',
      description: 'Experience the power of effortless marketing with our one-click solution campaign generator',
      status: 'completed',
      action: 'View'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Performance</h1>
        <LocationSwitcher
          selectedRegion={selectedRegion}
          selectedCountry={selectedCountry}
          onRegionChange={setSelectedRegion}
          onCountryChange={setSelectedCountry}
        />
      </div>

      {/* Performance Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {performanceMetrics.map((metric, index) => (
          <PerformanceMetric
            key={index}
            name={metric.name}
            score={metric.score}
            connected={metric.connected}
            onConnect={() => console.log(`Connect ${metric.name}`)}
          />
        ))}
      </div>

      {/* Quick Create */}
      <div>
        <h2 className="text-xl font-semibold mb-4">Quick Create</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {quickCreateItems.map((item, index) => (
            <QuickCreateCard
              key={index}
              title={item.title}
              icon={item.icon}
              bgColor={item.bgColor}
            />
          ))}
        </div>
      </div>

      {/* Get Started */}
      <div className="bg-white rounded-xl p-6">
        <h2 className="text-xl font-semibold mb-6">Get Started with AI GTM Engine</h2>
        <p className="text-sm text-gray-500 mb-6">Setup checklist</p>
        <div className="space-y-6">
          {setupSteps.map((step, index) => (
            <SetupStep
              key={index}
              number={index + 1}
              title={step.title}
              description={step.description}
              status={step.status}
              action={step.action}
              onAction={() => console.log(`Action: ${step.action}`)}
            />
          ))}
        </div>
      </div>

      {/* Campaign Section */}
      <Campaign />
    </div>
  );
}

export default StrategyDashboard;